import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getDocumentsId, getDocuments } from "../../redux/actions/actionDocument";
import { getItems } from "../../redux/actions/actionItem";
import { putPresupuesto } from "../../redux/actions/actionPresupuesto";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import Swal from "sweetalert2";
import DetailPresupuestoPDF from "./detailPrespuestoPdf";
import { customStylesItems } from "../../Constantes/constantesEstilos";
import { sumaCantidades, sumaTotalImporte, sumaCantidadesPresupuesto, sumaTotalImportePresupuesto } from "../../utils/sumaCantidades";
import { coeficiente } from "../../utils/coeficientes";
import { customStylesCoeficiente } from "../../Constantes/constantesEstilos";
import { use } from "react";

export default function PresupuestoModify() {
  let dateAux = format(new Date(), "yyyy/MM/dd");


  
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const documents = useSelector((state) => state.documents.allDocuments);
  const documentId = useSelector((state) => state.documents.documentsDetail);
  const items = useSelector((state) => state.items.allItems);
  const [pedido, setPedido] = useState(documentId)
  const [startDate] = useState(new Date());
  const [verPDF, setVerPDF] = useState(false);
  const [pdfBruto, setPdfBruto] = useState(false)
  
  console.log(pedido);
  console.log(pedido.itemsPresupuesto);
  
  

  useEffect(() => {
    dispatch(getDocuments());
    dispatch(getDocumentsId(id));        
  }, [dispatch, id]);

  useEffect(() => {
    if(documentId !== undefined) {
        setPedido(documentId)
    }    
  }, [documentId]);    

    //   useEffect(() => {
//     const savedPedido = localStorage.getItem('pedido');
//     if (savedPedido) {
//         setPedido(JSON.parse(savedPedido));
//     } else { return}
//   }, []);

//   useEffect(() => {
//     localStorage.setItem('pedido', JSON.stringify(pedido));
//   }, [pedido]);

  const opendPDF = () => {
    setVerPDF(true);
    setPdfBruto(false)
  };

  const brutoPDF = () => {
    setVerPDF(true);
    setPdfBruto(true)
}



  console.log(documentId);

  const handlePrice = (e, item) => {
    
      console.log(e.target.value);
      console.log(item);
      const {value} = e.target

    const updateItem = pedido.quantityItems.map(x => {
        if(x.item === item){
            x.price = value
            x.totalPrice = parseInt(value) * parseInt(x.quantity)
            x.totalPricePresupuesto = parseInt(value) * parseInt(x.presupuesto)
            setPedido({
                ...pedido,
            }) 
        }})    
  }

  const handlePresupuestoCantidad = (e, item) => {
    
      console.log(e.target.value);
      console.log(item);
      const {value} = e.target
      console.log("Valor", value);
      
      let numero = Number(value);
     if(isNaN(numero)){
      console.log("El valor ingresado no es un número");
      } else {
      console.log("El valor ingresado es un número");}

    const updateItem = pedido.quantityItems.map(x => {
      console.log(x.price);
      
        if(x.item === item){
            x.presupuesto = value
            x.totalPricePresupuesto = parseInt(value) * parseInt(x.price)
            setPedido({
                ...pedido,
            }) 
        }})    
  } 
  

const totalArticulos = pedido.quantityItems !== undefined ? sumaCantidades(pedido.quantityItems) : null; // total articulos
console.log(totalArticulos);
const importeSubtotal = pedido.quantityItems !== undefined ? sumaTotalImporte(pedido.quantityItems) : null; 
console.log(importeSubtotal);
const importeSubtotalPresupuesto = pedido.quantityItems !== undefined ? sumaTotalImportePresupuesto(pedido.quantityItems) : null;
console.log(parseInt(importeSubtotalPresupuesto));
const numeroReal = isNaN(Number(importeSubtotalPresupuesto)) ? "No es un numero" : "Es un numero"; // total importe presupuesto
console.log(numeroReal);


const totalCantidadPresupuesto = pedido.quantityItems !== undefined ? sumaCantidadesPresupuesto(pedido.quantityItems) : null; // total cantidad presupuesto
console.log(totalCantidadPresupuesto);
 
    
    useEffect( () => {
      setPedido(prevForm => ({
        ...prevForm,
        subtotal: importeSubtotal 
      }))
    }, [importeSubtotal]);

    useEffect( () => {
      setPedido(prevForm => ({
        ...prevForm,
        subTotalPresupuesto:importeSubtotalPresupuesto
      }))
    }, [importeSubtotalPresupuesto, totalCantidadPresupuesto]);

    
    
    const handleCoeficiente = (e) => {
      console.log(e.value);
      //console.log(totalImporte);
    let total;
    
    total = parseFloat(e.value) * parseFloat(importeSubtotalPresupuesto)
    //console.log(parseFloat(totalCoeficiente));    
    setPedido({
      ...pedido,
      //subtotal: totalImporte, 
      totalCoeficiente: total,
      coeficiente: e.value
    })
  }

  useEffect(() => {
    setPedido(prevForm => ({
      ...prevForm,
      subtotal: importeSubtotal, 
      subTotalPresupuesto: importeSubtotalPresupuesto,
      totalCoeficiente: pedido.coeficiente * importeSubtotalPresupuesto
    }))
  },[totalCantidadPresupuesto, importeSubtotalPresupuesto]);
  
  useEffect(() => {
    setPedido(() => ({
      ...pedido,
      totalCoeficiente: pedido.coeficiente * pedido.subtotal
    }))  
  }, [pedido.coeficiente, pedido.subtotal]);
  
  const handleSubmit = (e) => {
    //console.log(pedido);   
    dispatch(putPresupuesto(id, pedido))
    setTimeout(() => {
      navigate(`/presupuestos/${id}`)      
    }, 300);
  }
  
  const handleAgregados = (e) => {
        const { value } = e.target;
        const { name } = e.target;
        console.log("Nombre", name);
        console.log("Valor", value);
        const nameSplit = name.split("."); // separamos el nombre del input para obtener la clave y el valor
        console.log("nameSplit", nameSplit);
        const itemKey = nameSplit[0]; // obtenemos la clave del objeto
        console.log(itemKey);
        const itemKeyValue = nameSplit[1]; // obtenemos el valor del objeto
        console.log(itemKeyValue);
        
        
        //if(nameSplit[1] === "clave"){
          setPedido({
            ...pedido,
            [itemKey]: { ...pedido[itemKey], [nameSplit[1]]: value}
          });
        //}
      }

            
      useEffect(() => {
        let item1 = pedido.item1 ? parseInt(pedido.item1.valor) : 0;
        let item2 = pedido.item2 ? parseInt(pedido.item2.valor) : 0;        
        let item3 = pedido.item3 ? parseInt(pedido.item3.valor) : 0;
        let item4 = pedido.item4 ? parseInt(pedido.item4.valor) : 0;
        let totalCoeficiente = parseInt(pedido.totalCoeficiente);
        const suma = totalCoeficiente + item1 + item2 + item3 + item4
        setPedido( () => ({
          ...pedido,
          totalDocumento: suma
        }));
      },[pedido.totalCoeficiente, pedido.item1, pedido.item2, pedido.item3, pedido.item4]);

  return (
    <div className="container bg-gray-900">
            <div className="m-8 text-orange-500 text-[10pt] font-bold">
                <div className="text-xl pb-8 underline">
                    Presupuesto - Modificar
                </div>
                <div className="flex w-4/4 mt-6 border-b-2 border-slate-500 pb-2">
                    <p className="w-1/4">Documento N°: {pedido.numberDocument}</p>
                    <p className="w-1/4">Fecha: {pedido.createdAt ? format(new Date(pedido.createdAt), "dd/MM/yyyy") : ""}</p>
                    <div className="flex w-1/3">
                      <p>Facturas Asociadas:</p>
                      <input
                        className="ml-2 w-44 placeholder-orange-500 bg-slate-700"
                        type="text"
                        name="facturasAsociadas"
                        //placeholder={pedido.facturasAsociadas}
                        value={pedido.facturasAsociadas}
                        onChange={(e) => setPedido({
                          ...pedido,
                          facturasAsociadas: e.target.value
                        })}
                        requerid="true" 
                      />
                    </div>
                    {/* <p className="w-1/4">Estado: {documentId.approved === true ? "APROBADO" : " - "}</p>
                    {documentId.approved === false ? <button className="w-1/4" onClick={handleAprobar} value={"aprobado"}>Aprobar</button> : <p></p>} */}
                </div>
                <div>
                    {pedido.client_id === undefined ? (
                        <div className="py-2 pb-2 border-b-2 border-slate-500">
                        <div className="flex">
                            <p className="w-1/4">Cliente N°:</p>
                            <p className="w-1/4">Compañia:</p>
                            <p className="w-1/4">Nombre:</p>
                            <p className="w-1/4">Apellido:</p>
                        </div>
                        <div className="flex">
                            <p className="w-1/4">Dirección:</p>
                            <p className="w-1/4">Ciudad:</p>
                            <p className="w-1/4">Teléfonos:</p>
                            <p className="w-1/4">E-mail:</p>
                        </div>
                        </div>
                    ) : (
                        <div className="py-2 pb-2 border-b-2 border-slate-500">
                        <div className="flex">
                            <p className="w-1/4">Cliente N°: {pedido.client_id.idClient}</p>
                            <p className="w-1/4">Compañia: {pedido.client_id.nameCompany}</p>
                            <p className="w-1/4">Nombre: {pedido.client_id.name}</p>
                            <p className="w-1/4">Apellido: {pedido.client_id.lastName}</p>
                        </div>
                        <div className="flex">
                            <p className="w-1/4">Dirección: {pedido.client_id.address}</p>
                            <p className="w-1/4">Ciudad: {pedido.client_id.city}</p>
                            <p className="w-1/4">Teléfonos: {pedido.client_id.telephoneNumber}</p>
                            <p className="w-1/4">E-mail: {pedido.client_id.email}</p>
                        </div>
                        </div>
                    )}
                </div>
                <div className="flex w-3/3 border-b-2 border-slate-500 py-2">
                    <p className="w-1/3">Dirección de Evento: {pedido.addressEvent}</p>
                    <p className="w-1/3">Fecha de Envío: {pedido.dateSend ? format(new Date(pedido.dateSend), "dd/MM/yyyy") : ""}</p>
                    <p className="w-1/3">Fecha de Recepcion: {pedido.dateReception ? format(new Date(pedido.dateReception), "dd/MM/yyyy") : ""}</p>
                </div>
                <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
                </div>
                <div className="flex border-b-2 border-slate-500">
                    <p className="w-1/4">Nombre</p>
                    <p className="w-2/4">Descripción</p>
                    <p className="w-20 pl-5">Presupu -estado</p>
                    <p className="w-20 text-center">Cant. Pedido</p>
                    <p className="w-20 text-center">Pre Unit</p>
                    <p className="w-20 text-center">Importe</p>
                </div>
                <div>
                    {pedido.quantityItems && pedido.quantityItems.map(e=> {
                        return (
                            <div className="flex border-b-2 border-slate-500 text-[9pt]" key={e.item}>
                            <p className="w-1/4">{e.name}</p>
                            <p className="w-2/4 pl-2">{e.descrip}</p>
                            <input 
                                className="w-20 text-center placeholder-orange-500 bg-slate-700"
                                type="text"
                                name="changePresupuesto"
                                placeholder={e.presupuesto}
                                onChange={(x) => handlePresupuestoCantidad(x, e.item)}
                                //value={e.presupuesto}
                                requerid="true"
                            />
                            <p className="w-20 text-center">{e.quantity}</p>
                            {/* <p className="w-20 text-center">{e.price}</p> */}
                            <input 
                                className="w-20 text-center placeholder-orange-500 bg-slate-700"
                                type="text"
                                name="changePrice"
                                placeholder={e.price}
                                onChange={(x) => handlePrice(x, e.item)}
                                //value={e.price}
                                requerid="true"
                            />
                            <p className="w-20 text-center">{e.totalPrice}</p>                            
                            </div>
                        )
                    })
                    }
                </div>
                    <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
                        <div className="w-[1000px]">Subtotal</div>            
                        <div className="w-16 text-center">{pedido.subtotal}</div>            
                    </div>
                    <div className="flex flex-row text-[10pt] font-bold mt-5 border-b-2 border-slate-300">
                        <div className="w-[1000px]">Subtotal Presupuesto</div>            
                        <div className="w-16 text-center">{pedido.subTotalPresupuesto}</div>            
                    </div>
                    <div className="flex flex-row mt-10 border-b-2 border-white">
          <p className="w-24">Coeficiente</p>
          <div className="w-28 pt-[2px]">
          <Select
                styles={customStylesCoeficiente}
                placeholder={pedido.coeficiente}
                options={coeficiente.map((e) => ({ label: [e.dias, " -> ", e.valor], value: e.valor }))}
                onChange={handleCoeficiente}
                />
          </div>          
              <p className="w-[350px]"></p>
              <p className="w-16">
                Total
              </p>
              <p className="w-32">
                {pedido.totalCoeficiente}
              </p>
        </div>

        <div className="mt-4">
          <div className="flex">
            <p className="mr-2">Item 1</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item1.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item1.valor" placeholder={pedido.item1 ? pedido.item1.valor : ""} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 2</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item2.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item2.valor" placeholder={pedido.item2 ? pedido.item2.valor : ""} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 3</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item3.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item3.valor" placeholder={pedido.item3 ? pedido.item3.valor : ""} onChange={handleAgregados}/>
          </div>
          <div className="flex">
            <p className="mr-2">Item 4</p>
            <input className="bg-slate-700 border rounded w-40" type="text" name="item4.clave" onChange={handleAgregados}/>
            <input className="bg-slate-700 border rounded w-24 text-right" type="number" name="item4.valor" placeholder={pedido.item4 ? pedido.item4.valor : ""} onChange={handleAgregados}/>
          </div>
        </div>
        <div className="flex mt-5">
          <p className="mr-4">Total:</p>
          <p>{pedido.totalDocumento}</p>
        </div>


        <div className="flex flex-row justify-around w-1/3">
          <div>
            <button
              className="mt-12 p-4 rounded bg-gray-500 text-white hover:text-black"
              onClick={handleSubmit}
            >
              Guardar
            </button>
          </div>
          <div>
          <button
            className="mt-12 p-4 rounded bg-sky-500 text-white hover:text-black w-[130px] ml-4" 
            onClick={opendPDF}
            >
              Ver PDF
          </button>
          </div>
          <div>
          <button
            className="mt-12 p-4 rounded bg-red-500 text-white hover:text-black w-[130px] ml-4"
            onClick={brutoPDF}
            >
              Ver PDF bruto
          </button>
          </div>
        </div>
                <div>
          {verPDF ? (
            <div
              className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-0-sm
              flex flex-col justify-center items-center"
            >
              <div className="bg-red-500 w-1/12 text-center rounded hover:bg-red-600">
                <button
                  className="text-black font-bold hover:text-white"
                  onClick={() => setVerPDF(false)}
                >
                  Cerrar
                </button>
              </div>
              <div>
              <DetailPresupuestoPDF
                  key={id} 
                  id={id}
                  presupuesto={documentId}
                  bruto={pdfBruto}
              />
              </div>
            </div>
          ) : null}
        </div>
            </div>
        </div>
    )  
}